(function () {
  if (window.tmWishlistShareInitialized) return;
  window.tmWishlistShareInitialized = true;
  const entries = new Map();
  let scheduled = false;
  function getShareUrl(source) {
    const id = source.wishlist && source.wishlist.publicId;
    const util = source.app && source.app.utils && source.app.utils.url;
    if (!id || id === 'mine' || !util || typeof util.getPublicWishlistUrl !== 'function') return null;
    try {
      const url = new URL(util.getPublicWishlistUrl(id));
      if (url.protocol !== 'https:' || url.username || url.password || !url.pathname.endsWith('/' + id)) return null;
      return url.href;
    } catch (_) { return null; }
  }
  function closeOthers(current) {
    entries.forEach(ui => { if (ui !== current) ui.open = false; });
  }
  function enhance(source) {
    if (!getShareUrl(source)) return; // Keep the app's original control if its API changes.
    let ui = entries.get(source);
    if (ui && ui.isConnected) return;
    ui = document.createElement('details');
    ui.className = 'tm-wishlist-share';
    ui.innerHTML = '<summary class="tm-wishlist-share__trigger"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 16V3m-5 5 5-5 5 5M5 13v7h14v-7"/></svg><span>Share wishlist</span></summary><div class="tm-wishlist-share__panel"><button type="button" class="tm-wishlist-share__option" data-action="copy">Copy link</button><a class="tm-wishlist-share__option" data-action="whatsapp" target="_blank" rel="noopener noreferrer">Share on WhatsApp</a><a class="tm-wishlist-share__option" data-action="email">Share by email</a><button type="button" class="tm-wishlist-share__option" data-action="more">More sharing options</button><input class="tm-wishlist-share__link" type="text" readonly aria-label="Wishlist share link" hidden><span class="tm-wishlist-share__status" role="status" aria-live="polite"></span></div>';
    const status = ui.querySelector('.tm-wishlist-share__status');
    const field = ui.querySelector('input');
    const more = ui.querySelector('[data-action="more"]');
    more.hidden = typeof navigator.share !== 'function';
    function refresh() {
      const url = getShareUrl(source);
      if (!url) { status.textContent = 'The share link is not available. Please refresh the page and try again.'; return null; }
      field.value = url;
      ui.querySelector('[data-action="whatsapp"]').href = 'https://wa.me/?text=' + encodeURIComponent('Discover my Taller Marmo wishlist: ' + url);
      ui.querySelector('[data-action="email"]').href = 'mailto:?subject=' + encodeURIComponent('My Taller Marmo wishlist') + '&body=' + encodeURIComponent('Discover my Taller Marmo wishlist:\n' + url);
      return url;
    }
    refresh();
    ui.addEventListener('toggle', () => {
      if (ui.open) { closeOthers(ui); status.textContent = ''; field.hidden = true; refresh(); }
    });
    ui.addEventListener('click', async event => {
      const target = event.target.closest('[data-action]');
      if (!target) return;
      const url = refresh();
      if (!url) { event.preventDefault(); return; }
      const action = target.dataset.action;
      if (action === 'copy') {
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          status.textContent = 'Link copied';
        } catch (_) {
          field.hidden = false;
          field.focus();
          field.select();
          status.textContent = 'Select and copy the link above.';
        }
      } else if (action === 'more') {
        try {
          const data = {title: 'My Taller Marmo wishlist', text: 'Discover my Taller Marmo wishlist', url};
          if (navigator.canShare && !navigator.canShare(data)) throw new Error('Sharing unavailable');
          await navigator.share(data);
          status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = 'Sharing is not available here. Please use Copy link.';
        }
      }
    });
    source.insertAdjacentElement('afterend', ui);
    source.setAttribute('data-tm-share-enhanced', '');
    entries.set(source, ui);
  }
  function update() {
    scheduled = false;
    entries.forEach((ui, source) => {
      if (!source.isConnected || !ui.isConnected) {
        ui.remove();
        source.removeAttribute('data-tm-share-enhanced');
        entries.delete(source);
      } else if (!getShareUrl(source)) {
        ui.remove();
        source.removeAttribute('data-tm-share-enhanced');
        entries.delete(source);
      }
    });
    document.querySelectorAll('wishlist-page wishlist-share').forEach(enhance);
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }
  function init() {
    const root = document.body;
    new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
    schedule();
  }
  document.addEventListener('click', event => {
    entries.forEach(ui => { if (ui.open && !ui.contains(event.target)) ui.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') entries.forEach(ui => {
      if (ui.open) { ui.open = false; ui.querySelector('summary').focus(); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
